/**
 * Reads a cookie value by name from the browser cookie string.
 *
 * @param {string} name Cookie name to read.
 * @returns {string} Cookie value, or an empty string when not found.
 */
export const getCookie = (name) => {
  return (
    document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${name}=`))
      ?.split("=")[1] || ""
  );
};
